import config from 'config'


export const cloudinaryUrl = `https://res.cloudinary.com/${config.cloudinaryCloudName}`

export const isCloudinaryUrl = (url: string) => Boolean(url?.startsWith(cloudinaryUrl))

export const getCloudinaryVideoUrl = (url: string) => {
  if (!url) {
    return url
  }

  // ignore local video
  if (!url.match(/^https?:\/\//)) {
    return url
  }

  // if it's already cloudinary url, just return it
  if (url.startsWith(cloudinaryUrl)) {
    return url
  }

  // if it's our own video from the repo, just use direct repo id
  if (url.startsWith(config.assetsPath)) {
    return `${cloudinaryUrl}/video/upload/f_mp4/f/${url.replace(config.assetsPath, '')}`
  }

  return `${cloudinaryUrl}/video/fetch/f_mp4/${url}`
}

// direct links to our s3
const cloudinaryMap = [
  [ config.assetsPath, 'f/' ],
  [ `${cloudinaryUrl}/image/upload/`, '' ],
  [ 'https://cdn.scentbird.com/product/', 'p/' ],
  [ 'https://cdn.scentbird.com/notes/', 'n/' ],
]

export const getCloudinaryImageUrl = (url: string, options?: { width?: number, height?: number, quality?: number, bgColor?: string }) => {
  // ignore local file
  if (!url.match(/^https?:\/\//)) {
    return url
  }

  const { width, height, quality, bgColor } = options || {}

  // https://res.cloudinary.com/dphaojcfb/image/fetch/f_auto/q_85/c_scale,w_864/b_rgb:fff/https://cdn.scentbird.com/*

  let resourceType = 'upload'
  let parts: string[] = []

  if (width > 0 || height > 0) {
    parts.push(`c_scale,${width ? `w_${width}` : `h_${height}`}`)
  }

  if (quality) {
    parts.push(`q_${quality}`)
  }

  if (bgColor) {
    parts.push(`b_rgb:${bgColor.replace('#', '')}`)
  }

  const replaced = cloudinaryMap.some(([ from, to ]) => {
    if (url.startsWith(from)) {
      parts.push(url.replace(from, to))
      return true
    }
  })

  if (!replaced) {
    resourceType = 'fetch'
    parts.push(url)
  }

  parts.unshift(`${cloudinaryUrl}/image/${resourceType}/f_auto`)

  return parts.join('/')
}

export const getCloudinaryAssetUrl = (url: string) => {
  // ignore local file
  if (!url.match(/^https?:\/\//)) {
    return url
  }

  if (url.match(/\.(jpg|png|gif)$/)) {
    return getCloudinaryImageUrl(url)
  }

  if (url.match(/\.(mp4)$/)) {
    return getCloudinaryVideoUrl(url)
  }

  if (url.startsWith(config.assetsPath)) {
    return `${cloudinaryUrl}/raw/upload/f/${url.replace(config.assetsPath, '')}`
  }

  return `${cloudinaryUrl}/raw/fetch/${url}`
}
